/**
 * Increments a buyer reference by adding or updating a numeric suffix.
 *
 * Examples:
 * - "my number" -> "my number - 2"
 * - "my number - 2" -> "my number - 3"
 * - "my number - 3" -> "my number - 4"
 *
 */

export const getIncrementedBuyerReference = (buyerReference: string): string => {
    // Match pattern: "<base> - <number>" at the end of the string
    const suffixPattern = /^(.*)\s-\s(\d+)$/;
    const match = buyerReference.match(suffixPattern);

    if (match) {
        // Extract base and current number
        const base = match[1];
        const currentNumber = parseInt(match[2], 10);
        const nextNumber = currentNumber + 1;
        return `${base} - ${nextNumber}`;
    }

    // No suffix found, add " - 2"
    return `${buyerReference} - 2`;
};
